/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.
//==============================================================
// START Enums and Input Objects
//==============================================================
/**
 * Used to identify the downstream data source.
 * ENTITY: A stateful data service driven by the owning domain
 * CART: Cart Service
 * OFFER: Offer Service
 * ORDER: Ordering Service
 */
export var DataSourceType;
(function (DataSourceType) {
    DataSourceType["CART"] = "CART";
    DataSourceType["ENTITY"] = "ENTITY";
    DataSourceType["OFFER"] = "OFFER";
    DataSourceType["ORDER"] = "ORDER";
})(DataSourceType || (DataSourceType = {}));
//==============================================================
// END Enums and Input Objects
//==============================================================
//# sourceMappingURL=globalTypes.js.map